<template>
  <scout-form
    :is-modified="!!value.length"
    :label="label"
    :half="half"
  >
    <div
      v-if="selectedOption !== undefined"
      class="boss-layout boss-layout-start boss-layout-gap-large"
      data-test="prefecture-option"
    >
      <label
        v-for="(option, i) in prefectureOptions"
        :key="i"
        :data-test="`label-${i}`"
        class="pega-input"
      >
        <input
          :checked="selectedOption === option.key"
          :value="option.key"
          :data-test="`radio-${i}`"
          class="boss-input-checkbox"
          type="radio"
          @change="$emit('update:selectedOption', $event.target.value)"
        >{{ option.label }}
      </label>
    </div>
    <label
      v-if="containWorkPrefecturesNonHopeUser !== undefined"
      data-test="use-option-checkbox"
      class="boss-checkbox"
    >
      <input
        :checked="containWorkPrefecturesNonHopeUser"
        class="boss-input-checkbox"
        type="checkbox"
        data-test="check-box"
        @change="$emit('update:containWorkPrefecturesNonHopeUser', $event.target.checked)"
      >希望勤務地が未入力の会員を含む
    </label>
    <label
      v-if="showAnnotationLabel"
      class="boss-annotation-text"
      data-test="show-annotation"
    >
      ※プリセットでは、勤務地に近い地域が選択されています。
    </label>
    <select-modal-button
      v-if="prefecturesMaster.length > 0"
      :master-data="prefecturesMaster"
      :selected-items="value.map(n => { return { id: n, experience: '' } })"
      title="都道府県"
      suffix="prefectures"
      :is-wrap-category="true"
      :is-ellipsis="true"
      data-test="modal"
      :can-accordion="true"
      @update-modal-checked-ids="value => update(value)"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import * as definition from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ScoutForm,
    SelectModalButton
  },
  props: {
    selectedOption: {
      default: undefined,
      type: String
    },
    prefectures: {
      required: true,
      type: Array
    },
    cities: {
      required: true,
      type: Array
    },
    label: {
      default: '現住所・希望勤務地',
      type: String
    },
    half: {
      default: false,
      type: Boolean
    },
    containWorkPrefecturesNonHopeUser: {
      default: undefined,
      type: Boolean
    },
    showAnnotationLabel: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      prefectureOptions: definition.prefecturesWhich
    }
  },
  computed: {
    ...mapGetters([
      'prefecturesMaster'
    ]),
    value () {
      return [...this.prefectures, ...this.cities]
    },
    prefectureIdsMaster () {
      return this.prefecturesMaster
        .flatMap(area =>
          area.children.map(prefecture => prefecture.id)
        )
    }
  },
  methods: {
    update (value) {
      const groupingIds = _.groupBy(
        value.flatMap(prefecture => {
          if (prefecture.children.length) {
            return prefecture.children.map(city => city.id)
          } else {
            return prefecture.id
          }
        }),
        id => { return this.prefectureIdsMaster.includes(id) }
      )
      this.$emit('update:prefectures', _.get(groupingIds, 'true', []))
      this.$emit('update:cities', _.get(groupingIds, 'false', []))
    }
  }
}
</script>
